import { useEffect, createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Modal,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Flex,
  Dropdown,
  MenuProps,
} from "antd";

import { DownOutlined } from "@ant-design/icons";

import ObjectForm from "components/Admin/ObjectForm";

import { RootState } from "Redux/store";
import { fetchActionCategory, updateActionCategory, createActionCategory, deleteActionCategory } from "Redux/Admin/ProjectManager/ActionCategories/action";

import { settings, initialSettings, initialValues } from './const';
import { ADMIN_PATH } from "utils/routes";

import type { IActionCategory } from 'Redux/Admin/ProjectManager/ActionCategories/type';

const ActionCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const isNew = id === 'new';

  const { entities, loading, error } = useSelector((state: RootState) => state.fetchActionCategories);

  const [modal, contextHolder] = Modal.useModal();

  const ReachableContext = createContext<string | null>(null);

  useEffect(() => {
    if (id && !isNew) {
      dispatch(fetchActionCategory(id));
    }
  }, [dispatch, isNew, id]);

  const onFinish = (values: any) => {
    if (isNew) {
      dispatch(createActionCategory(values, handleCreate));
    }
    else if (id) {
      dispatch(updateActionCategory(values, id));
    }
  };

  const handleCreate = (project: IActionCategory) => {
    if (project && project.id) {
      navigate(`${ADMIN_PATH}/project-manager/action-categories/${project.id}`);
    }
  }

  if (!id) {
    navigate(`${ADMIN_PATH}/project-manager/action-categories`, { replace: true });
    return null;
  }

  const actionCategory = isNew ? initialValues : entities[id];

  if (!actionCategory) {
    return <Spin />;
  }

  const menuItems: MenuProps['items'] = [
    /* {
      label: 'View Areas',
      key: '1',
    }, */
    {
      label: 'Delete Action Category',
      key: '2',
      danger: true,
    }
  ];

  const modalConfig = {
    title: 'Delete the action category?',
    content: <span>Are you sure you want to delete the action category <b>{actionCategory.id}</b>?</span>,
    confirmLoading: true
  };

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    /* if (e.key === '1') {
      navigate(`${ADMIN_PATH}/goals/journeys/user-areas/?masterplan=${id}`);
    }
    else  */if (e.key === '2') {
      const confirmed = await modal.confirm(modalConfig);

      if (confirmed) {
        dispatch(deleteActionCategory(id, () => {
          navigate(`${ADMIN_PATH}/project-manager/action-categories`, { replace: true });
        }));
      }
    }
  };

  const menuProps = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <ReachableContext.Provider value="Light">
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Row>
          <Col span={12}>
            <Flex
              gap="middle"
              align="center"
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Link to={`${ADMIN_PATH}/project-manager/action-categories`}>Back</Link>
            </Flex>

            <Card title={`${isNew ? 'Create' : '' } Action Category`} extra={
              isNew ? null : <Dropdown menu={menuProps} placement="bottom">
                <Button>
                  <Space>
                    Manage Action Category
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            }>
              <ObjectForm
                data={actionCategory}
                errorData={error}
                isNew={isNew}
                settings={isNew ? initialSettings : settings}
                loading={loading}
                onFinish={onFinish}
              />
            </Card>
          </Col>
        </Row>
      </div>

      {contextHolder}
    </ReachableContext.Provider>
  );
}

export default ActionCategory;
